<template>
	<div>
		<h5>MultiTerminalRepair</h5>
	</div>
</template>

<script>
	export default {
		name: "MultiTerminalRepair",
	};
</script>

<style scoped></style>
